import { LocalPhone, LocationOn, MailOutline, WhatsApp } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import facebook from '../../assets/img/facebook.png';
import instagramIcon from '../../../src/assets/img/instagramIcon.jfif'
import twitter from '../../../src/assets/img/twitter.png'
import linkedin from '../../../src/assets/img/linkedin.png'
import WhatsApp_icon from '../../../src/assets/img/WhatsApp_icon.png.webp'
import { useDispatch, useSelector } from 'react-redux';
import { categories } from '../../store/apiSlice/categoriesSlice';


const Footer = () => {
    const dispatch = useDispatch();
    const navigation = useNavigate();
    const categoriesData = useSelector((state) => state.rootReducer.categoriesReducer.data);
    const [nannycatData, setNannycatData] = useState(null);

    useEffect(() => {
        dispatch(categories());
    }, []);

    useEffect(() => {
        if (categoriesData != null && categoriesData.status === 1) {
            setNannycatData(categoriesData.data);
        }
    }, [categoriesData]);



    const [visible, setVisible] = useState(false)

    const toggleVisible = () => {
        const scrolled = document.documentElement.scrollTop;
        if (scrolled > 300) {
            setVisible(true)
        }
        else if (scrolled <= 300) {
            setVisible(false)
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    window.addEventListener('scroll', toggleVisible);

    return (
        <>
            <div className="footer_banner_bg sections_padding position-relative ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <h5 className="fw-700 mb-3 mb-md-5 mt-2 mt-md-0">About Us</h5>
                            <p>Our professional and experienced nannies are always available. You can rely on us daytime, nighttime, anytime!</p>
                            <br />
                            <p>We aim to take good care of our nannies as it’s important that you/they feel supported by the agency to ensure a positive working relationship. We understand that it’s crucial for everybody that the nanny is in a good place so that they deliver the best possible care.</p>
                            <div onClick={() => { scrollToTop(); navigation('/privacy_policy') }} style={{ cursor: 'pointer' }}>
                                <p onClick={scrollToTop} className="mt-4 d-block text-decoration-underline">Privacy & Policy</p>
                            </div>
                            <div onClick={() => { scrollToTop(); navigation('/term_condition') }} style={{ cursor: 'pointer' }}>
                                <p onClick={scrollToTop} className="mt-4 d-block text-decoration-underline">Term & Condition</p>
                            </div>
                        </div>
                        <div className="col-md-3 offset-md-1">
                            <h5 className="fw-700 mb-3 mb-md-5 mt-4 mt-md-0">Services</h5>
                            <ul>
                                {/* <li onClick={() => { scrollToTop(); navigation('/privacy_policy') }} style={{ cursor: 'pointer' }}>
                                    <p onClick={scrollToTop} className="d-block">Privacy policy</p>
                                </li> */}
                                {nannycatData && Array.isArray(nannycatData) && nannycatData != null ?
                                    nannycatData.map((item) =>
                                        <li key={item._id} onClick={() => { scrollToTop(); navigation(`/services_details/${item._id}`) }} style={{ cursor: 'pointer' }}>
                                            <a to="#" className="mb-4 d-block">{item.name}</a>
                                        </li>
                                    ) : (
                                        ""
                                    )}
                            </ul>
                        </div>
                        <div className="col-md-3">
                            <h5 className="fw-700 mb-3 mb-md-5 mt-4 mt-md-0">Contact</h5>
                            <div className="d-flex align-items-center contact_section mb-4">
                                <LocationOn />
                                <p>Placa del Duc de Medicinalei 08002, Barcelona</p>
                            </div>
                            <div className="d-flex align-items-center contact_section mb-4">
                                <img src={WhatsApp_icon} alt='WhatsApp_icon' style={{ borderRadius: "50%", width: 33, height: 33, marginRight: 10 }} />
                                <p>+34 617 24 36 59</p>
                            </div>
                            <div className="d-flex align-items-center contact_section mb-4">
                                <MailOutline />
                                <p>info@nanny-line.com </p>
                            </div>
                            <div className="d-flex align-items-center contact_section mb-4">
                                <Link to="https://www.instagram.com/thenannyline.co/" target='_blank' >
                                    <img src={instagramIcon} alt='instagramIcon' style={{ borderRadius: "50%", width: 33, height: 33 }} className='me-3' />
                                </Link>
                                <Link to="https://www.facebook.com/thenannyline" target='_blank'>
                                    <img src={facebook} alt='facebook' style={{ borderRadius: "50%", width: 30, height: 30 }} className='me-3' />
                                </Link>
                                <Link to="https://x.com/thenannyline" target='_blank'>
                                    <img src={twitter} alt='twitter' style={{ borderRadius: "50%", width: 35, height: 35 }} className='me-3' />
                                </Link>
                                <Link to="https://www.linkedin.com/company/the-nanny-line/" target='_blank'>
                                    <img src={linkedin} alt='linkedin' style={{ borderRadius: "50%", width: 33, height: 33 }} />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" />
                </div>
            </div>
        </>
    )
}

export default Footer